<footer class="footer-component-w">
  <app-footer-card />
  <app-footer-base />
</footer>
